module.exports = __webpack_public_path__ + "037d96dd5bd66a08257610a748056825.png";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/making-money.png
// module id = 3712
// module chunks = 2